import type { PageFormProps } from '../types/layout';

const PageForm = ({
  title,
  description,
  children,
  footer,
  onSubmit,
  className = '',
  formClassName = '',
  bodyClassName = '',
}: PageFormProps) => {
  return (
    <form className={`card app-surface app-form-surface ${className} ${formClassName}`.trim()} onSubmit={onSubmit}>
      {(title || description) && (
        <div className="card-header app-surface__header">
          <div className="app-section-header">
            <div className="app-section-header__copy">
              {title && <h3 className="card-title app-section-title">{title}</h3>}
              {description && <div className="app-section-description">{description}</div>}
            </div>
          </div>
        </div>
      )}
      <div className={`card-body app-form-surface__body ${bodyClassName}`.trim()}>{children}</div>
      {footer && <div className="card-footer app-form-surface__footer">{footer}</div>}
    </form>
  );
};

export default PageForm;
